
export default {
  name: 'SpecList',
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    itemsFilter() {
      return this.items.filter((item) => item.value);
    },
  },
  methods: {
    getValue(value) {
      return Array.isArray(value) ? value.join(', ') : value;
    },
  },
}
